import { APIJobs } from '@platform/client';
import { EmailTabSection } from '../../components/EmailTabSection';

export const ProEmailTabContent = ({ proId }: { proId: number }) => {
  const { data: emailData, isLoading, isError, isSuccess } = APIJobs.useGetUserEmailJobs(proId);

  return (
    <EmailTabSection
      data={emailData}
      isLoading={isLoading}
      isError={isError}
      isSuccess={isSuccess}
      recordType='professional'
    />
  );
};
